import moment from "moment";
import pageControl from "@/csrc/common/PageControl.vue";
import popupLayout from "@/csrc/common/PopupLayout.vue";
const store = window.sessionStorage;
export default{
	data(){
		return {
			
		}
	},
	methods:{
		setStore(key, content){
			if(["object"].includes((typeof content))){
				store.setItem(key, JSON.stringify(content));
			}else{
				store.setItem(key, content);
			}
		},
		getStore(key){
			return store.getItem(key);
		},
		clearStore(){
			store.clear();
		},
		removeStore(key){
			store.removeItem(key);
		},
		htmlEncode(encodeValue){
			const div = document.createElement('div');
			div.appendChild(document.createTextNode(encodeValue));
			return div.innerHTML;
		},
		htmlDecode(decodeValue){
			const div = document.createElement('div');
			div.innerHTML = decodeValue;
			return div.innerText || div.textContent;
		},
		downloadFile(res, fileName) {
			if (window.navigator && window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(new Blob([res]), fileName);
			} else {
				const url = window.URL.createObjectURL(new Blob([res]));
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", fileName);
				document.body.appendChild(link);
				link.click();
			}
		},
		inputFilter(textbox, filter){
			["input", "focusout"].forEach(event => {
				textbox.addEventListener(event, (x) => {
					if(filter(x.target.value)){
						x.target.oldValue = x.target.value;
						x.target.oldSelectionStart = x.target.selectionStart;
						x.target.oldSelectionEnd = x.target.selectionEnd;
					}else if("oldValue" in x.target){
						x.target.value = x.target.oldValue;
					}else{
						x.target.value = "";
					}
				});
			})
			
		},
		nowDate(){
			return new Date(this.customFormatter(new Date));
		},
		customFormatter(date, formatString) {
			if(!formatString){
				formatString = "YYYY/MM/DD";
			}
			return moment.tz(date, "Asia/Taipei").format(formatString);
		},
		dateFormatter(date) {
			return moment.tz(date, "Asia/Taipei").toDate();
		},
		gotoView(pathName, params) {
			if(params){
				this.setStore(pathName, params);
			}
			this.$router.push({ name: pathName, params:params});
		},
		
		compresImage(file){
			let _this = this;
			return new Promise(resolve =>{
				if(!file || !window.FileReader){
					resolve(file);
				}else{
					let reader = new FileReader();
					reader.readAsDataURL(file);
					reader.onloadend = function(){
						let result = this.result;
						let image = new Image();
						image.src = result;
						if(this.result.length <= 100 * 1024){
							resolve(file);
						}else{//圖片壓縮
							image.onload = function() {
								let dataURI = _this.compress(image);
								let byteString = "";
								if (dataURI.split(',')[0].indexOf('base64') >= 0)
									byteString = atob(dataURI.split(',')[1]);
								else
									byteString = unescape(dataURI.split(',')[1]);

								let ia = new Uint8Array(byteString.length);
								for (let i = 0; i < byteString.length; i++) {
									ia[i] = byteString.charCodeAt(i);
								}
								let resultImg = new File([new Uint8Array(ia)], file.name, {type: file.type});
								// console.log(resultImg);
								resolve(resultImg);
							};
						}
					}
				}
			});
		},
		compress(img){
			let canvas = document.createElement("canvas");
			let ctx = canvas.getContext("2d");
			//瓦片canvas
			let tCanvas = document.createElement("canvas");
			let tctx = tCanvas.getContext("2d");
			// let initSize = img.src.length;
			let width = img.width;
			let height = img.height;
			//如果圖片大於四百萬畫素，計算壓縮比並將大小壓至400萬以下
			let ratio;
			if ((ratio = width * height / 4000000) > 1) {
				// console.log("大於400萬畫素");
				ratio = Math.sqrt(ratio);
				width /= ratio;
				height /= ratio;
			} else {
				ratio = 1;
			}
			canvas.width = width;
			canvas.height = height;
			//鋪底色
			ctx.fillStyle = "#fff";
			ctx.fillRect(0, 0, canvas.width, canvas.height);
			//如果圖片畫素大於100萬則使用瓦片繪製
			let count;
			if ((count = width * height / 1000000) > 1) {
				// console.log("超過100W畫素");
				count = ~~(Math.sqrt(count) + 1); //計算要分成多少塊瓦片
				//            計算每塊瓦片的寬和高
				let nw = ~~(width / count);
				let nh = ~~(height / count);
				tCanvas.width = nw;
				tCanvas.height = nh;
				for (let i = 0; i < count; i++) {
					for (let j = 0; j < count; j++) {
						tctx.drawImage(img, (i * nw * ratio), (j * nh * ratio), (nw * ratio), (nh * ratio), 0, 0, nw, nh );
						ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
					}
				}
			} else {
				ctx.drawImage(img, 0, 0, width, height);
			}
			
			//進行最小壓縮
			let ndata = canvas.toDataURL("image/jpeg", 0.1);
			// console.log("壓縮前：" + initSize);
			// console.log("壓縮後：" + ndata.length);
			// console.log("壓縮率：" + ~~(100 * (initSize - ndata.length) / initSize) + "%" );
			tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
			return ndata;
		},
		
		toUserParam(){
			return {
				schoolId:this.$root.userInfo.schoolId, 
				schoolName:this.$root.userInfo.school
			}
		},
	},
	computed:{
	},
	components:{
		pageControl,
		popupLayout,
	},

}